import { Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

export const Wrapper = styled("div")(({ theme }) => ({
  backgroundColor: "white",
  borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  padding: "10px 20px",
  display: "flex",
  gap: "0px",
  position: "sticky",
  top: "0px",
  zIndex: "1000",
  justifyContent: "space-between",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    padding: "28px 12px",
    flexDirection: "column",
    gap: "10px",
    alignItems: "initial",
  },
}))
export const BreadcrumWrapper = styled("div")`
  display: flex;
  gap: 5px;
  flex-direction: column;
`

export const HeaderContent = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}))

export const TitleContainer = styled("div")(({ theme }) => ({
  width: "max-content",
  height: "30px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  background:
    "linear-gradient(90deg, rgba(255, 193, 0, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%)",
  [theme.breakpoints.down("sm")]: {
    marginLeft: "30px",
  },
}))

export const VerticalDiv = styled("div")`
  width: 4px;
  height: inherit;
  margin-right: 12px;
  background-color: #ffc100;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`

export const StyledText = styled(Typography)`
  font-size: 24px;
  font-weight: 700;
`
